/* ==========================================================================
   TSHART CRAFT T-SHIRT SIZE GUIDE MODAL & URL HASH CONTROLLER
   ========================================================================== */

(function() {
  function initSizeGuide() {
    const modal = document.getElementById('TshirtSizeGuideModal');
    if (!modal) return;

    function openModal() {
      modal.classList.add('is-active');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function closeModal() {
      modal.classList.remove('is-active');
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (window.location.hash === '#size-guide') {
        history.pushState('', document.title, window.location.pathname + window.location.search);
      }
    }

    // 1. Intercept Click Events for any #size-guide links or triggers
    document.addEventListener('click', function(e) {
      const trigger = e.target.closest('[data-open-size-guide], [data-size-guide-trigger], a[href="#size-guide"], a[href$="#size-guide"]');
      if (trigger) {
        e.preventDefault();
        openModal();
      }
    });

    // 2. Close Modal Buttons & Overlay
    modal.querySelectorAll('[data-close-size-guide], .tshirt-size-guide-overlay, .tshirt-size-guide-close').forEach(function(el) {
      el.addEventListener('click', function(e) {
        e.preventDefault();
        closeModal();
      });
    });

    // 3. Close on Escape Key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && modal.classList.contains('is-active')) {
        closeModal();
      }
    });

    // 4. Handle Direct URL Navigation (e.g. https://tshartcraft.com/#size-guide)
    function checkUrlHash() {
      if (window.location.hash === '#size-guide') {
        openModal();
      }
    }

    window.addEventListener('hashchange', checkUrlHash);
    checkUrlHash();

    // 5. CM / INCH Unit Switcher
    const unitButtons = modal.querySelectorAll('.tshirt-unit-btn, .unit-btn');
    const table = modal.querySelector('.tshirt-size-table');

    unitButtons.forEach(function(btn) {
      btn.addEventListener('click', function() {
        const unit = this.getAttribute('data-unit') || 'cm';
        unitButtons.forEach(b => b.classList.remove('is-active', 'active'));
        this.classList.add('is-active');
        
        if (table) {
          table.setAttribute('data-unit-view', unit);
          const cells = table.querySelectorAll('td[data-cm][data-in]');
          cells.forEach(cell => {
            const val = unit === 'in' ? cell.getAttribute('data-in') + ' in' : cell.getAttribute('data-cm') + ' cm';
            cell.textContent = val;
          });
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSizeGuide);
  } else {
    initSizeGuide();
  }
})();
